import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-50" }
const _hoisted_2 = { class: "max-w-screen-2xl mx-auto px-4 sm:px-6 w-full md:px-8 mb-10 md:mb-0" }
const _hoisted_3 = { class: "block lg:flex justify-between flex-col md:flex-row w-full md:items-center border-t-2 border-brand-500" }
const _hoisted_4 = { class: "flex flex-row justify-center md:justify-start w-full mt-2 gap-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center text-center md:text-left md:justify-end w-full mt-2 md:mr-4 text-xs flex-col md:flex-row sm:space-x-8 sm:py-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Email: music@crystalwedding.jp ")
], -1)

import ConfirmationCard from './ConfirmationCard.vue'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// store
	import { 
		localesStore
	} from '@/store/locales'
	// store
	import { 
		store as useJobStore
	} from '@/store/job'

	import { 
		LangTypes
	} from '@/types' // must be imported since file contains an export statement

	import EventBus from '@/events'

	import {
		ref
	} from 'vue'

	
	// name the component
	const __default__ = { name: "PageFooter" }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const store = localesStore()
	const jobStore = useJobStore()
	const {t, locale} = useI18n()

	const selectedLanguage = ref<LangTypes>('en' as LangTypes)

	function confirmSetLanguage(lang: LangTypes) {
		selectedLanguage.value = lang
		if(jobStore.job.loggedIn) toggleSaveSongModal()
		else setLanguage()
	}

	function setLanguage() {
		locale.value = selectedLanguage.value
		store.locales.selected = selectedLanguage.value

		// emit global event to reload data in new language
		EventBus.trigger('change-language', null)
	}

	const confirmationModal = ref<{open: boolean}>({open: false})
	function toggleSaveSongModal() {
		confirmationModal.value.open = !confirmationModal.value.open
	}


return (_ctx: any,_cache: any) => {
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("footer", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmSetLanguage('en' as LangTypes)))
          }, " English "),
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSetLanguage('ja' as LangTypes)))
          }, " 日本語 (漢字) "),
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmSetLanguage('kana' as LangTypes)))
          }, " 日本語 (仮名) ")
        ]),
        _hoisted_5
      ])
    ]),
    _createVNode(_component_tw_modal, {
      title: _unref(t)('nav.changeLanguageTitle'),
      "modal-max-width": "sm:max-w-xs md:max-w-3xl  bottom-80 h-fit sm:bottom-0",
      ref_key: "confirmationModal",
      ref: confirmationModal
    }, {
      default: _withCtx(() => [
        _createVNode(ConfirmationCard, {
          onCancel: toggleSaveSongModal,
          onSave: _cache[3] || (_cache[3] = () => {toggleSaveSongModal(); setLanguage()}),
          description: _unref(t)('nav.changeLanguage')
        }, null, 8, ["description"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})